var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CHeader',{staticStyle:{"background-color":"#4786ff !important"},attrs:{"with-subheader":""}},[_c('CHeaderBrand',{staticClass:"mx-auto d-lg-none",attrs:{"to":"/"}}),_c('CHeaderNav',{staticClass:"d-md-down-none mr-auto"},[_c('CHeaderNavItem',{staticClass:"px-12"})],1),_c('CHeaderNav',[_c('TheHeaderDropdownAccnt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }